/**
 * Продуктовая шкала известности для city-quest каталога.
 * Оценивает узнаваемость/место в типичном маршруте, не «качество» места.
 */
export enum AttractionFameEnum {
    ICON = 'icon',
    WELL_KNOWN = 'well_known',
    OFFBEAT = 'offbeat',
    HIDDEN_GEM = 'hidden_gem',
}
